// src/api/transcribe.js
import { api } from "../lib/apiClient";

/**
 * Envoie un fichier audio au backend Xano pour transcription.
 * @param {Blob} audioBlob - Le fichier audio (webm, wav, mp3...)
 * @param {string} authToken - Jeton d'authentification utilisateur
 * @returns {Promise<string|null>} - Le texte transcrit ou null si erreur.
 */
export async function transcribeAudio(audioBlob, authToken) {
  try {
    const formData = new FormData();
    formData.append("file", audioBlob, "recording.webm");

    const { data } = await api.post("/transcribe", formData, {
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    });

    return data?.response.result.text || null;
  } catch (err) {
    console.error("Erreur lors de la transcription:", err);
    return null;
  }
}
